import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  imageUrl: {
    desktop: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png',
    mobile: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png'
  },
  imageAccessibilityProps: {
    accessibilityRole: 'image',
    accessibilityLabel: 'image'
  },
  title: 'Log in to Airtel Business Self-Assist',
  primaryCta: {
    title: 'Log In',
    buttonType: 'secondary'
  },
  onPrimaryCtaPress: {
    id: 'action object',
    actions: [{
      payload: {
        shouldOpenWindow: true,
        externalUrl: 'https://www.airtel.in/business/b2b/whatsapp-api'
      },
      type: 'navigation'
    }]
  },
  infoList: [{
    icon: 'PayBillIcon',
    text: 'View payment details'
  }, {
    icon: 'PaymentSettingIcon',
    text: 'Access payment history'
  }, {
    icon: 'CustomerSupportIcon',
    text: 'Get real time assistance on requests'
  }],
  style: {
    backgroundColor: '#E3E5FF'
  },
  heightConfig: {
    desktop: 500,
    mobile: 380
  }
}, getTestId('ImageBannerWidgetContainer'));